import { useEffect, useState } from "react";
import contraList from "../../data/contraindications.json";

export default function Contraindications({ parent, med, update }) {
    const [expanded, setExpanded] = useState(false);
    const [contraindications, setContraindications] = useState([]);

    useEffect(() => {
        setContraindications(
            contraList
                .filter(indc => med.contraindications.includes(indc))
        );
    }, [med.contraindications]);

    const changeView = () => setExpanded(e => !e);

    return (
        <div className="contraindications">
            <div className="dropdown" onClick={changeView}>Contraindications ⮟</div>
            <div className={`checklist ${!expanded ? "hidden" : ""}`}>
                {contraindications.map(c => (
                    <div key={c} className="contraindication">
                        <label>
                            <input 
                                type="checkbox" 
                                onChange={update} 
                                value={c}
                                name="contraindications"
                                defaultChecked={parent.contraindications.includes(c)}
                            />
                            {c}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    )
}